import TyumenOurHomeFilter from './component'

export default TyumenOurHomeFilter
